import charity from '../assets/icons/charity.svg';
import church from '../assets/icons/church.svg';
import community from '../assets/icons/community.svg';
import greek from '../assets/icons/greek-life.svg';
import labor from '../assets/icons/labor.svg';
import school from '../assets/icons/school.svg';
import social from '../assets/icons/social.svg';
import sports from '../assets/icons/sports.svg';
import temp from '../assets/icons/temp.svg';
import veteran from '../assets/icons/veteran.svg';
import question from '../assets/icons/question.svg';

import hourly from '../assets/icons/worker-hourly.svg';
import subcontractor from '../assets/icons/worker-subcontractor.svg';

const npoTypes = [
  { value: 'CHARITY', label: 'Charity', img: charity },
  { value: 'CHURCH', label: 'Church', img: church },
  { value: 'COMMUNITY_GROUP', label: 'Community Group', img: community },
  { value: 'GREEK', label: 'Sorority/Fraternity', img: greek },
  { value: 'HOURLY', label: 'Hourly', img: hourly },
  { value: 'LABOR_UNION', label: 'Labor Union', img: labor },
  { value: 'OTHER', label: 'Other', img: question },
  { value: 'SCHOOL', label: 'School', img: school },
  { value: 'SOCIAL', label: 'Social', img: social },
  { value: 'SPORTS_TEAM', label: 'Sports Team', img: sports },
  { value: 'SUBCON', label: 'Subcontract', img: subcontractor },
  { value: 'TEMP', label: 'Temp Agency', img: temp },
  { value: 'VETERAN', label: 'Veteran / Military', img: veteran },
].reduce(
  (acc, item) => ({
    ...acc,
    [item.value]: item,
  }),
  {},
);

const getIconByNpoType = npoType => npoTypes[npoType].img || question;

export { getIconByNpoType };

export const NPO_TEMP_TYPE = npoTypes.TEMP.value;
export const NPO_HOURLY_TYPE = npoTypes.HOURLY.value;
export const NPO_SUBCONTRACTOR_TYPE = npoTypes.SUBCON.value;

export default npoTypes;



// WEBPACK FOOTER //
// ./src/enums/npoTypes.js